<p>participant-actions-accompagnement-card works!</p>
